import React, { useCallback, useState } from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { IDevice } from '@pages/Assets/Inventory/types';
import { IDeviceActionRequestPayload } from '../types';

interface IActionSmsBlock {
  handleDeviceActions: (item: IDeviceActionRequestPayload) => void;
  devicesProps: IDevice[] | undefined;
  uploadedDevices: any;
}

const useActionSmsBlock = ({
  handleDeviceActions,
  devicesProps,
  uploadedDevices,
}: IActionSmsBlock) => {
  const [extraAction, setextraAction] = useState(12);
  const { t: translate } = useTranslation(['device-actions-modal']);

  const contentSteps = [
    {
      title: translate('steps.sms-block.name'),
      content: (
        <div>
          <Radio.Group
            name="radiogroup"
            defaultValue={12}
            style={{ width: '100%' }}
            value={extraAction}
            onChange={e => {
              setextraAction(e.target.value);
            }}
          >
            <div style={{ marginTop: '10px' }}>
              <Radio value={12}>
                {translate('steps.sms-block.description')}
              </Radio>
            </div>
            <div
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                display: 'block',
              }}
            >
              <Radio value={13}>
                {translate('steps.sms-block.description2')}
              </Radio>
            </div>
          </Radio.Group>
        </div>
      ),
    },
  ];

  const reinitState = () => {
    setextraAction(12);
  };
  const onSubmit = useCallback(async () => {
    const payload: IDeviceActionRequestPayload = {};
    payload.action = extraAction;

    payload.devices =
      devicesProps && devicesProps?.length > 0
        ? devicesProps?.map(device => {
            return { msisdn: device.msisdn };
          })
        : uploadedDevices;

    return handleDeviceActions(payload);
  }, [handleDeviceActions, extraAction, devicesProps, uploadedDevices]);

  const smsBlockData = {
    contentSteps,
    onSubmit,
    reinitState,
    extraAction,
  };

  return { smsBlockData };
};

export default useActionSmsBlock;
